import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import {
  PaperClipOutlined,
  StarFilled,
  StarOutlined,
  CheckOutlined,
} from '@ant-design/icons';
import { Checkbox } from 'antd';
import moment from 'moment';
// Local Deps
import Actions from './subComponents/actions';
import './MessageCenterGrid.scss';

export default class MessageCenterGrid extends React.PureComponent {
  static propTypes = {
    // conversations: PropTypes.arrayOf(
    //   PropTypes.shape({
    //     id: PropTypes.string.isRequired,
    //     sender: PropTypes.string.isRequired,
    //     hasAttachment: PropTypes.bool.isRequired,
    //     newMessage: PropTypes.bool.isRequired,
    //     date: PropTypes.string.isRequired,
    //   }),
    // ).isRequired,
    conversations: PropTypes.any.isRequired,
    pageNumber: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    onPageSizeChange: PropTypes.func.isRequired,
    rawSelected: PropTypes.any,
    selectAll: PropTypes.string,
    starred: PropTypes.any,
    markConversationsStarred: PropTypes.func.isRequired,
    getSelectedConversations: PropTypes.func.isRequired,
    changeSelectAllValue: PropTypes.func.isRequired,
    selectedAction: PropTypes.func.isRequired,
    setPageInfo: PropTypes.func.isRequired,
    setSelectedConvo: PropTypes.func.isRequired,
    // setMessageNotification: PropTypes.func.isRequired,
    activeKey: PropTypes.string.isRequired,
  };

  static defaultProps = {
    rawSelected: { '5dc88d09998810bd915f5554': true },
    selectAll: 2,
    starred: ['5dc88d09e9f2c2eb48b7b50d'],
  };

  toggleRow(id) {
    console.log(this.props.rawSelected);
    const newSelected = { ...this.props.rawSelected };
    if (newSelected[id]) {
      newSelected[id] = !this.props.rawSelected[id];
      if (!newSelected[id]) {
        delete newSelected[id];
      }
    } else {
      newSelected[id] = true;
    }

    const showButton = Object.keys(newSelected).length === 0 ? 0 : 2;
    this.props.changeSelectAllValue(newSelected, showButton);
    this.props.getSelectedConversations(Object.keys(newSelected));
  }

  toggleSelectAll() {
    //  TODO: currently selects all need to change it so it selects the 20 or so showing and then adding a pop up similar gmail saying you have 20 conversations selected. select all ${count} messages in ${Folder Name}
    let conversations = [...this.props.conversations];
    const starting = this.props.pageNumber * 20;
    const ending = (this.props.pageNumber + 1) * 20;
    conversations = conversations.slice(starting, ending);
    const newSelected = {};
    console.log(conversations);
    if (this.props.selectAll === 0) {
      conversations.forEach(x => {
        newSelected[x.id] = true;
      });
    }
    const showButton = this.props.selectAll === 0 ? 1 : 0;
    this.props.changeSelectAllValue(newSelected, showButton);
    this.props.getSelectedConversations(Object.keys(newSelected));
  }

  render() {
    const {
      conversations,
      pageCount,
      onPageChange,
      onPageSizeChange,
      starred,
      markConversationsStarred,
      selectedAction,
      setPageInfo,
      setSelectedConvo,
      // setMessageNotification,
      activeKey,
    } = this.props;
    const columns = [
      {
        id: 'checkbox',
        accessor: '',
        Cell: cellProps => (
          <Checkbox
            checked={this.props.rawSelected[cellProps.original.id] === true}
            onChange={() => {
              this.toggleRow(cellProps.original.id);
            }}
          />
        ),
        Header: () => (
          <Checkbox
            checked={this.props.selectAll === 1}
            indeterminate={this.props.selectAll === 2}
            onChange={() => this.toggleSelectAll()}
          />
        ),
        sortable: false,
        width: 45,
      },
      {
        Header: () => <StarFilled />,
        accessor: 'isStarred',
        Cell: cellProps => {
          // TODO: Rewrite this to do an object look up to improve performance.
          const index = starred.indexOf(cellProps.original.id);
          if (index >= 0) {
            return (
              <div
                role="button"
                tabIndex={0}
                onClick={() => {
                  markConversationsStarred(cellProps.original.id);
                }}
                onKeyDown={e => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    markConversationsStarred(cellProps.original.id);
                  }
                }}
                aria-label="Star conversation"
              >
                <div id="line1" style={{ cursor: 'pointer' }}>
                  <StarFilled />
                </div>
              </div>
            );
          }
          return (
            <div
              role="button"
              tabIndex={0}
              style={{ cursor: 'pointer' }}
              id="line1"
              onClick={() => {
                markConversationsStarred(cellProps.original.id);
              }}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  markConversationsStarred(cellProps.original.id);
                }
              }}
              aria-label="Star conversation"
            >
              <StarOutlined />
            </div>
          );
        },
        sortable: false,

        width: 45,
      },
      {
        Header: 'Company',
        accessor: 'sender',
        Cell: cellProps => {
          let style = {};
          if (cellProps.original.newMessage) {
            style = { fontWeight: '600' };
          }
          return <span style={style}>{cellProps.value}</span>;
        },
      },
      {
        Header: 'Subject',
        accessor: 'subject',
        Cell: cellProps => {
          let style = {};
          if (cellProps.original.newMessage) {
            style = { fontWeight: '600' };
            // setMessageNotification();
          }
          if (cellProps.original.attachmentsFlag) {
            return (
              <span style={style}>
                {cellProps.value} <PaperClipOutlined />
              </span>
            );
          }

          return <span style={style}>{cellProps.value}</span>;
        },
      },
      {
        Header: 'Date',
        accessor: 'date',
        Cell: cellProps => {
          let style = {};
          if (cellProps.original.newMessage) {
            style = { fontWeight: '600' };
          }
          if (cellProps.value) {
            const newDate = moment
              .utc(`${cellProps.value}.000Z`)
              .local()
              .format('MM-DD-YYYY hh:mm:ss a');
            return <span style={style}>{newDate}</span>;
          }
          return <span />;
        },
      },

      {
        Header: 'Viewed',
        accessor: 'seen',
        width: 75,
        Cell: cellProps => {
          if (cellProps.original.received) {
            return (
              <span>
                {cellProps.value} <CheckOutlined />
              </span>
            );
          }
          return <span />;
        },
      },

      {
        Header: '',
        accessor: 'action',
        width: 100,

        Cell: cellProps => (
          <Actions cellProps={cellProps} selectedAction={selectedAction} activeKey={activeKey} />
        ),
      },
    ];
    return (
      <div className="nf-messagecenter-grid">
        <ReactTable
          data={conversations}
          columns={columns}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
          onFetchData={pageinfo => {
            setPageInfo(pageinfo);
          }}
          pages={pageCount}
          getTdProps={(state, rowInfo, column) => {
            const index = rowInfo ? rowInfo.index : -1;
            return {
              onClick: () => {
                console.log(rowInfo);
                if (
                  column.id === 'isStarred' ||
                  column.id === 'checkbox' ||
                  column.id === 'action'
                ) {
                  return;
                }
                this.selectedRow = index;
                if (rowInfo && rowInfo.original && rowInfo.original.id) {
                  setSelectedConvo(
                    rowInfo.original.id,
                    rowInfo.original.participants,
                  );
                }
              },
            };
          }}
          pageSize={20}
          showPageSizeOptions={false}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/grids/MessageCenterGrid/MessageCenterGrid.jsx